module.exports = __webpack_public_path__ + "img/Logo_DTC-ai-svg.2b763960.svg";